export const EMAIL_DESIGN_ELEMENTS_SIDEBAR = {
    OPEN_WEBSITE_LINK_DROPDOWN_VALUE: {
        key: 'OPEN_WEBSITE_LINK_DROPDOWN_VALUE',
        value: 'Open Website'
    },
    SEND_EMAIL_LINK_DROPDOWN_VALUE: {
        key: 'SEND_EMAIL_LINK_DROPDOWN_VALUE',
        value: 'Send Email'
    },
    CALL_PHONE_LINK_DROPDOWN_VALUE: {
        key: 'CALL_PHONE_LINK_DROPDOWN_VALUE',
        value: 'Call phone'
    },
    LINK_INPUT_LABEL: {
        key:'LINK_INPUT_LABEL',
        value: 'Link'
    },
    EMAIL_ADDRESS_INPUT_LABEL: {
        key: 'EMAIL_ADDRESS_LABEL',
        value: 'Email Address'
    },
    PHONE_NUMBER_INPUT_LABEL: {
        key: 'PHONE_NUMBER_INPUT_LABEL',
        value: 'Phone Number'
    },
    BUTTON_DEFAULT_STYLES_HEADING: {
        key: 'BUTTON_DEFAULT_STYLES_HEADING',
        value: 'Default Styles'
    },
    SPACING_BETWEEN_SOCIAL_LINKS_LABEL: {
        key: 'SPACING_BETWEEN_SOCIAL_LINKS_LABEL',
        value: 'Spacing between icons'
    },
    WEB_ADDRESS_LABEL: {
      key: 'WEB_ADDRESS',
      value: 'Web Address'
    },
    READ_AS_LABEL: {
      key: 'READ_AS',
      value: 'Read As'
    }
};

export const CREATE_VARIABLE_POPUP = {
  EMPTY_VARIABLES_LIST_MESSAGE: {
    key: 'EMPTY_VARIABLES_LIST_MESSAGE',
    value: 'Variable list is empty try to create new one!!',
  },

  VARIABLES_LIST_MULTI_VALUE_VARIABLE_TOOLTIP: {
    key: 'VARIABLES_LIST_MULTI_VALUE_VARIABLE_TOOLTIP',
    value: 'List Variable',
  },

  VARIABLES_LIST_DATE_VARIABLE_TOOLTIP: {
    key: 'VARIABLES_LIST_DATE_VARIABLE_TOOLTIP',
    value: 'Date Variable',
  },
  VARIABLES_LIST_HTML_VARIABLE_TOOLTIP: {
    key: 'VARIABLES_LIST_HTML_VARIABLE_TOOLTIP',
    value: 'HTML Variable',
  },
  ONE_TO_MANY_RELATION_TOOLTIP: {
    key: 'ONE_TO_MANY_RELATION_TOOLTIP',
    value: 'One to Many Relation'
  },
  CREATE_NEW_VARIABLE_LABEL: {
    key: 'CREATE_NEW_VARIABLE_LABEL',
    value: 'Create variable',
  },
  CREATE_NEW_VARIABLE_NAME_LABEL: {
    key: 'CREATE_NEW_VARIABLE_NAME_LABEL',
    value: 'Variable Name',
  },
  CREATE_NEW_VARIABLE_NAME_PLACEHOLDER: {
    key: 'CREATE_NEW_VARIABLE_NAME_PLACEHOLDER',
    value: 'Name your variable',
  },
  CREATE_NEW_VARIABLE_LENGTH_LABEL: {
    key: 'CREATE_NEW_VARIABLE_LENGTH_LABEL',
    value: 'Max characters',
  },
  VALIDATE_MAX_CHARACTERS: {
    key: 'VALIDATE_MAX_CHARACTERS',
    value: 'Validate max characters',
  },
  VALIDATIONS_LABEL: {
    key: 'VALIDATIONS_LABEL',
    value: 'Validations',
  },
  CREATE_NEW_REQUIRED_LABEL: {
    key: 'CREATE_NEW_REQUIRED_LABEL',
    value: 'Required',
  },
  CREATE_NEW_VARIABLE_LENGTH_PLACEHOLDER: {
    key: 'CREATE_NEW_VARIABLE_LENGTH_PLACEHOLDER',
    value: 'Maximum characters (greater than 0)',
  },
  CREATE_NEW_VARIABLE_REQUIRED_INPUT_LABEL: {
    key: 'CREATE_NEW_VARIABLE_REQUIRED_INPUT_LABEL',
    value: '*Required.',
  },
  LIST_OF_VALUES_LABEL: {
    key: 'LIST_OF_VALUES_LABEL',
    value: 'List of values',
  },
  CREATE_NEW_VARIABLE_DATA_TYPE_LABEL: {
    key: 'CREATE_NEW_VARIABLE_DATA_TYPE_LABEL',
    value: 'Data Type',
  },
  CREATE_NEW_VARIABLE_DATA_TYPE_STRING_OPTION: {
    key: 'CREATE_NEW_VARIABLE_DATA_TYPE_STRING_OPTION',
    value: 'String',
  },
  CREATE_NEW_VARIABLE_DATA_TYPE_DATE_OPTION: {
    key: 'CREATE_NEW_VARIABLE_DATA_TYPE_DATE_OPTION',
    value: 'Date',
  },
  CREATE_NEW_VARIABLE_MAXIMUM_LINES_PLACEHOLDER: {
    key: 'CREATE_NEW_VARIABLE_MAXIMUM_LINES_PLACEHOLDER',
    value: 'Maximum number of lines (greater than 0)',
  },
  DISPLAY_NAME: {
    key: 'DISPLAY_NAME',
    value: 'Display name (max 50)',
  },
  DISPLAY_NAME_LABEL: {
    key: 'DISPLAY_NAME_LABEL',
    value: 'Display Name',
  },
  CREATE_NEW_VARIABLE_EXAMPLE_LABEL: {
    key: 'CREATE_NEW_VARIABLE_EXAMPLE_LABEL',
    value: 'Example',
  },
  CREATE_NEW_VARIABLE_EXAMPLE_PLACEHOLDER: {
    key: 'CREATE_NEW_VARIABLE_EXAMPLE_PLACEHOLDER',
    value: 'Example for preview',
  },
  CANCEL_CREATE_NEW_VARIABLE_BUTTON: {
    key: 'CANCEL_CREATE_NEW_VARIABLE_BUTTON',
    value: 'Cancel',
  },
  SAVE_NEW_VARIABLE_BUTTON: { key: 'SAVE_NEW_VARIABLE_BUTTON', value: 'Save' },
  CLOSE_BUTTON: {
    key: 'CLOSE_BUTTON',
    value: 'Close',
  },
  CREATE_NEW_VARIABLE_FAILURE: {
    key: 'CREATE_NEW_VARIABLE_FAILURE',
    value: 'An error occured while trying to add a variable',
  },
};

export const CUSTOM_LOGIC_POPUP = {
  LOGIC_TITLE: {
    key: 'LOGIC_TITLE',
    value: 'LOGIC',
  },
  UPDATE_BUTTON: {
    key: 'UPDATE_BUTTON',
    value: 'Update',
  },
  SAVE_BUTTON: {
    key: 'SAVE_BUTTON',
    value: 'Save',
  }
}
